import * as React from "react";
import { makeStyles, shorthands, tokens, Title3, Text } from "@fluentui/react-components";
import { ErrorCircle24Regular } from "@fluentui/react-icons";
import { useTypographyStyles } from "../../styles/typography.styles";

/**
 * Terminal error state shown when the addin is launched in standalone mode
 * (browser tab outside Excel) but the URL is missing a `?spreadsheetId=`
 * parameter. Standalone can't resolve which workbook to show without it —
 * unlike Excel mode, there's no workbook attached to the addin to read the
 * metadata from.
 */

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    ...shorthands.padding(tokens.spacingVerticalXXL),
    textAlign: "center",
  },
  icon: {
    color: tokens.colorPaletteRedForeground1,
    marginBottom: tokens.spacingVerticalM,
  },
  title: {
    marginBottom: tokens.spacingVerticalM,
  },
  body: {
    maxWidth: "500px",
    marginBottom: tokens.spacingVerticalS,
  },
});

const StandaloneMissingIdError: React.FC = () => {
  const styles = useStyles();
  const typography = useTypographyStyles();

  return (
    <div className={styles.root}>
      <ErrorCircle24Regular className={styles.icon} />
      <Title3 className={styles.title}>Missing or invalid spreadsheet ID</Title3>
      <Text as="p" className={`${typography.bodyLarge} ${styles.body}`}>
        The <code>?spreadsheetId=</code> parameter is missing from the URL,
        or the workbook it points to no longer exists.
      </Text>
      <Text as="p" className={`${typography.bodyLarge} ${styles.body}`}>
        Open your workbook in Excel and use the <strong>Pop out</strong>
        {" "}button in the sidebar to get a working standalone link.
      </Text>
    </div>
  );
};

export default StandaloneMissingIdError;
